import { SearchBarField, SearchBarIcon, SearchBarStyles } from "./styles";

export default function SearchBar() {
    return (
        <SearchBarStyles>
            <SearchBarIcon src='' />
            <SearchBarField placeholder='Search' />
        </SearchBarStyles>
    )
}